export const faq = [
  {
    id: "1",
    question: "Сколько времени занимает подбор администратора?",
    answer: "В среднем от 7 до 14 дней с момента подписания договора до выхода кандидата на первую смену. Для сложных позиций или VIP-объектов срок может составлять до 3 недель — за это время мы проводим углубленный поиск и расширенное обучение.",
  },
  {
    id: "2",
    question: "Работаете ли вы с объектами в регионах?",
    answer: "Да, мы работаем по всей России. Для удалённых регионов предусмотрена гибридная модель: подбор и первичное обучение проводятся онлайн, финальная адаптация — на площадке заказчика. Стоимость услуг для региональных объектов не отличается от столичных.",
  },
  {
    id: "3",
    question: "Что входит в обучение администраторов?",
    answer: "Обучение включает: стандарты гостеприимства и первого контакта, работу с CRM и системами бронирования, конфликтологию и работу с жалобами, основы СМК (в премиум-тарифе), адаптацию под специфику конкретного объекта. По завершении администратор получает сертификат.",
  },
  {
    id: "4",
    question: "Можно ли внедрить только CRM без подбора персонала?",
    answer: "Да, в тарифе Профессионал и Премиум CRM внедряется как отдельный модуль. Однако мы рекомендуем комплексный подход — новая система работает эффективнее, когда персонал обучен работать с ней с самого начала.",
  },
  {
    id: "5",
    question: "Как происходит гарантия замены сотрудника?",
    answer: "В течение 3 месяцев с момента выхода на работу, если подобранный администратор не справляется с обязанностями, увольняется или не соответствует ожиданиям — мы бесплатно подбираем замену. Гарантия действует в тарифах Профессионал и Премиум.",
  },
  {
    id: "6",
    question: "Что такое СМК и зачем она нужна гостинице?",
    answer: "СМК — система менеджмента качества. Для гостиничных объектов это структурированный набор процессов, который гарантирует стабильное качество обслуживания. Внедрение СМК помогает пройти государственные проверки, получить сертификаты и повысить доверие гостей.",
  },
  {
    id: "7",
    question: "Какой минимальный размер объекта, с которым вы работаете?",
    answer: "Мы работаем с объектами от 15 номеров — мини-отели, гостевые дома, небольшие хостелы. Для объектов меньше 15 номеров рекомендуем тариф Старт. Верхний порога нет: мы успешно обслуживали сетевые отели на 500+ номеров.",
  },
  {
    id: "8",
    question: "Какие CRM-системы вы внедряете?",
    answer: "Внедряем решения под бюджет и масштаб клиента: от простых облачных CRM (Битрикс24, МойСклад) до специализированных гостиничных систем (Oracle Hospitality, 1С:Отель). Выбор зависит от количества номеров, интеграций и бюджета.",
  },
];